export default "__VITE_ASSET__Z4rqNj$v__"